module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/clear-day-54288da67b71b4b19483d373d683257f.svg";